jQuery(function($){
	// init form fields
	var $street = $("[data-name='street'] input");
	var $housenr = $("[data-name='house_number'] input");
	var $city = $("[data-name='city'] input");
	var $fields = $street.add($housenr).add($city);
	var $search = $(".acf-google-map input.search");

	// check fields
	if($fields.length == 3 && $search.length > 0) {

		// on change
		$fields.change(function(){

			// init
			var iFilledValues = 0;

			// loop fields and validate values
			$fields.each(function(){
				if($(this).val() != '') iFilledValues += 1;
			});

			// all fields filled
			if(iFilledValues == 3 && $search.val() == '') {
				var address = $street.val() + " " + $housenr.val() + ', ' + $city.val() + ', The Netherlands';
				$search.val(address).siblings(".actions").find("[data-name='search']").click();
			}
		});
	}

});